require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./packages-fashion-marketing-packages.json") })
        }
      }, "path---packages-fashion-marketing-packages");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---packages-fashion-marketing-packages!./.cache/json/packages-fashion-marketing-packages.json
// module id = 722
// module chunks = 231608221292675